import { render, staticRenderFns } from "./OpenEndedContent.vue?vue&type=template&id=c616d524&scoped=true&"
import script from "./OpenEndedContent.vue?vue&type=script&lang=js&"
export * from "./OpenEndedContent.vue?vue&type=script&lang=js&"
import style0 from "./OpenEndedContent.vue?vue&type=style&index=0&id=c616d524&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c616d524",
  null
  
)

export default component.exports